import styled from "styled-components";
import { defaultTheme } from "../styles/themes/defaultTheme";

export const UserAvatar = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${({ theme }) => defaultTheme.colors.primary};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
    cursor: pointer;
  }
`;

export const MinUserAvatar = styled.div`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  font-size: 12px;
  background-color: ${({ theme }) => defaultTheme.colors.primary};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  &:hover {
    transform: scale(1.1);
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
    cursor: pointer;
  }
`;